module.exports = __webpack_public_path__ + "static/apple-logo-tile-f60e1d90a5405327223ae0c8f7fbc461.png";